module.exports = __webpack_public_path__ + "static/media/alson_chan.f04fa509.jpg";